/** @module utils/isSpotheroAdmin */

/**
 * Email addresses that should not be considered Spothero Admins.
 * @private
 */
const EXCEPTIONS: string[] = [
    'theparkingspot-api@spothero.com',
    'operator-api@spothero.com',
    'iconintegration@spothero.com',
    'icon_api_user@spothero.com ',
];

/**
 * Determines if a user is a Spothero Admin.
 *
 * @param email - The email address to check.
 * @returns `true` if the email belongs to a Spothero Admin and is not in the exceptions list, otherwise `false`.
 */
const isSpotheroAdmin = (email: string = ''): boolean => {
    if (!email) {
        return false;
    }

    return email.includes('@spothero.com') && !EXCEPTIONS.includes(email);
};

export default isSpotheroAdmin;
